import { Injectable } from '@angular/core';

import { Http, Headers, Response, RequestOptions,  } from '@angular/http';
import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class ParplatzData {
  data: any;
  ppstatusdata : any;

  constructor(public http: Http, public common: CommonData, public userData: UserData) {
    this.ppstatusdata = [];
  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load() {
    if (this.data) {
      return Promise.resolve(this.data);
    }

    // don't have the data yet
    return new Promise(resolve => {
      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'grundstuecke/getall?token='+this.userData.jwt).subscribe(res => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          //this.data = this.processData(res.json());
          this.data = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer pp-data.ts');
          console.log(error);
      });

      }
    });
  }

  mandatbyppid(ppid){
    let i=0;
    for(i=0; i<this.data.length; i++){
      if(this.data[i].grundid == ppid){
        return this.data[i].fkmandat;                
      }
    }
    return -1;
  }

  shortnamebyid(ppid){
    //console.log(ppid);
    let i=0;
    for(i=0; i<this.data.length; i++){
      if(this.data[i].grundid == ppid){
        //console.log(this.data[i].kurzname);
        return this.data[i].kurzname;                
      }
    }
    return ppid;    
  }

  ppbyshortname(shortname){
    for(let i=0; i<this.data.length; i++){
      if(this.data[i].kurzname == shortname){
        return this.data[i];                
      }
    }
    return null;
  }

  processData(data) {
    // just some good 'ol JS fun with objects and arrays
    // build up the data by linking speakers to sessions

    data.tracks = [];
/*
    // loop through each day in the schedule
    data.schedule.forEach(day => {
      // loop through each timeline group in the day
      day.groups.forEach(group => {
        // loop through each session in the timeline group
        group.sessions.forEach(session => {
          this.processParkplaetze(data, session);
        });
      });
    });
*/
    return data;
  }

  processParkplaetze(data, session) {
    // loop through each speaker and load the speaker data
    // using the speaker name as the key
/*
    session.speakers = [];
    if (session.speakerNames) {
      session.speakerNames.forEach(speakerName => {
        let speaker = data.speakers.find(s => s.name === speakerName);
        if (speaker) {
          session.speakers.push(speaker);
          speaker.sessions = speaker.sessions || [];
          speaker.sessions.push(session);
        }
      });
    }

    if (session.tracks) {
      session.tracks.forEach(track => {
        if (data.tracks.indexOf(track) < 0) {
          data.tracks.push(track);
        }
      });
    }
*/    
  }

  getParkplaetze() {
    return this.load().then(data => {
      //console.log("getParkplaetze"+ data);
      return data;
    });
  }



  ppstatus(grundid) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        console.log(grundid);
        this.http.get(this.common.baseurl+'grundstueckstatuse/statusdata?grundid='+grundid+'&token='+this.userData.jwt).subscribe(res => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          //this.data = this.processData(res.json());
          this.ppstatusdata = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer pp-data.ts');
          console.log(error);
      });

      }
    });
  }

  loadKontrollinfo(grundid) {
    return new Promise(resolve => {
      if(this.userData.loggedin){        
     
        this.http.get(this.common.baseurl+'grundstuecke/loadkontrollinfo?grundid='+grundid+'&token='+this.userData.jwt).subscribe(res => {
          
          if(res.json().data){
            resolve(res.json().data.body);
          }
          else{
            resolve();
          }
          
        }, error => {
          console.log('HTTP Error, no answer info');
          console.log(error);
      });

      }
    });
  }  

}



// WEBPACK FOOTER //
// ./src/providers/pp-data.ts